import { HttpsStatusCode } from './http-status-code';

export interface IHttpError extends Error {
  readonly response: Response;
  readonly status: HttpsStatusCode;
}

export class HttpError extends Error implements IHttpError {
  public static get ErrorName() { return 'HttpError'; }

  constructor(private httpResponse: Response) {
    super(httpResponse.statusText);

    Object.setPrototypeOf(this, HttpError.prototype);
  }

  public get response(): Response {
    return this.httpResponse;
  }

  public get status(): HttpsStatusCode {
    return this.httpResponse.status;
  }

  public get name(): string {
    return HttpError.ErrorName;
  }
}
